<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :inline="true"
        :rules="rules"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="波次分组方式："
              prop="waveGroupType"
            >
              <el-checkbox-group
                v-model="formData.waveGroupType"
                :disabled="isDetail"
              >
                <el-checkbox
                  v-for="checkbox in WAVE_GROUP_OPTIONS"
                  :key="checkbox.label"
                  :label="checkbox.value"
                  :disabled="checkbox.value === 'SHIPPER'"
                >
                  {{ checkbox.label }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <prescription
              :time.sync="formData.executeMaxTime"
              :time-type.sync="formData.timeUnit"
              :disabled="isDetail"
            />
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="3"
          :table-data="formData.ruleFlowTaskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import Prescription from '../../components/Prescription.vue';
import TaskSetting from './TaskSetting.vue';
import { WAVE_GROUP_OPTIONS, NODE_TYPE } from './constant';

export default {
  components: {
    ListBlock,
    Prescription,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      WAVE_GROUP_OPTIONS,
      rules: {
        waveGroupType: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(3);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[3].label}”节点数据`);
        }
      });
    },
  },
};
</script>
